import {
  FETCH_RELEASES_REQUEST,
  FETCH_RELEASES_SUCCESS,
  FETCH_RELEASES_FAILURE,
  OPEN_EDIT_RELEASE_PAGE,
  FETCH_RELEASE_REQUEST,
  FETCH_RELEASE_SUCCESS,
  FETCH_RELEASE_FAILURE,
  UPDATE_RELEASES_REQUEST,
  UPDATE_RELEASES_FAILURE,
  UPDATE_RELEASES_SUCCESS,
  DELETE_RELEASES_REQUEST,
  DELETE_RELEASES_FAILURE,
  DELETE_RELEASES_SUCCESS,
  CLEAR_RELEASE_ERRORS,    // Nouvelles imports
  CLEAR_RELEASE_SUCCESS,
} from './actionTypes';

const initialState = {
  releases: [],
  release: null,
  loadingRelease: false,
  errorRelease: null,
  editItemId: null,
  releaseAdded: null
};

const Releases = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_RELEASES_REQUEST:
      return {
        ...state,
        loadingRelease: true,
        errorRelease: null,
        releaseAdded: false
      };
    case FETCH_RELEASES_SUCCESS:
      return {
        ...state,
        loadingRelease: false,
        releases: action.payload,
      };
    case FETCH_RELEASES_FAILURE:
      return {
        ...state,
        loadingRelease: false,
        errorRelease: action.payload,
      };
    case FETCH_RELEASE_REQUEST:
      return {
        ...state,
        loadingRelease: true,
        errorRelease: null,
        releaseAdded: false
      };
    case FETCH_RELEASE_SUCCESS:
      return {
        ...state,
        loadingRelease: false,
        release: action.payload,
      };
    case FETCH_RELEASE_FAILURE:
      return {
        ...state,
        loadingRelease: false,
        errorRelease: action.payload,
      };
    case UPDATE_RELEASES_REQUEST:
      return {
        ...state,
        loadingRelease: true,
        errorRelease: null,
        releaseAdded: false
      };
    case UPDATE_RELEASES_SUCCESS:
      return {
        ...state,
        loadingRelease: false,
        release: null,
        releaseAdded: true
      };
    case UPDATE_RELEASES_FAILURE:
      return {
        ...state,
        loadingRelease: false,
        errorRelease: action.payload,
      };
    case DELETE_RELEASES_REQUEST:
      return {
        ...state,
        loadingRelease: true,
        errorRelease: null,
        releaseAdded: false
      };
    case DELETE_RELEASES_SUCCESS:
      return {
        ...state,
        releaseAdded: true,
        loadingRelease: false,
        releases: state.releases.filter(release => release.id !== action.payload),
      };
    case DELETE_RELEASES_FAILURE:
      return {
        ...state,
        loadingRelease: false,
        errorRelease: action.payload,
      };
    case OPEN_EDIT_RELEASE_PAGE:
      return {
        ...state,
        editItemId: action.payload.id,
      };
    case CLEAR_RELEASE_ERRORS:
      return {
        ...state,
        errorRelease: null,
      };
    case CLEAR_RELEASE_SUCCESS:
      return {
        ...state,
        releaseAdded: null,
      };
      
    default:
      return state;
  }
};

export default Releases;